module.exports = __webpack_public_path__ + "img/avatar6.df13075d.png";